import React from "react";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import Button from "@components/Button/Button";
import { useUploadStore } from "@components/FileUpload/uploadStore";
import Subheader from "@components/Subheader/Subheader";
import PortCalls from "@features/vessel-call/grid/PortCalls";
import PageLayout from "@layouts/PageLayout";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { paths } from "@utils/navigation";
import { checkPermission } from "@utils/user-permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useVesselCallFormStore } from "./create/store/useVesselCallForm.store";

const LANG_BASE = "vessel-call.portCalls";
const TEST_ID_BASE = "vessel-call-page";

const VesselCallContainer: React.FC = () => {
  const { userActionPermissions } = useAuthStore();

  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";

  const addVesselCall = () => {
    useVesselCallFormStore.getState().resetForm();
    useUploadStore.getState().clearAll();
    navigate(`/${paths.vesselCall.index}/${paths.vesselCall.vesselScan}`);
  };

  return (
    <PageLayout dir={dir}>
      <Subheader
        testId={`${TEST_ID_BASE}-subheader`}
        subtitle={t("navigation.vessel-call")}
        title={
          <div className="flex items-end justify-between w-full">
            <span>{t(`${LANG_BASE}.title`)}</span>
            {checkPermission(userActionPermissions, "canWriteVesselCall") && (
              <Button
                type="button"
                variant="contained"
                color="primary"
                label={t(`${LANG_BASE}.addVesselCall`)}
                testId={`${TEST_ID_BASE}-add-vessel-call-button`}
                sx={{ height: "40px", minHeight: "40px", textTransform: "none" }}
                onClick={addVesselCall}
                startIcon={<ControlPointIcon />}
              />
            )}
          </div>
        }
      />
      <div className="pt-8 pb-8 px-24 flex flex-col gap-6">
        <PortCalls />
      </div>
    </PageLayout>
  );
};

export default VesselCallContainer;
